// js
import React from 'react';
import PropTypes from 'prop-types';
import Button from '../common/Button';
import Tooltip from '../common/Tooltip';


const CloneDSAButton = ({ onClick, tooltipPosition }) => {
  const tooltipText = `
    An existing DSA may be cloned to use as a
    starting point for a new assessment,
    or to model different data volume &
    indexing scenarios for a customer
  `;

  return (
    <div className='clone-dsa-button'>
      <Tooltip position={tooltipPosition} text={tooltipText}>
        <Button
          label='Clone'
          onClick={onClick}
        />
      </Tooltip>
    </div>
  );
};

CloneDSAButton.defaultProps = {
  tooltipPosition: 'top'
};

CloneDSAButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  tooltipPosition: PropTypes.string
};

export default CloneDSAButton;



// WEBPACK FOOTER //
// ./src/components/account/CloneDSAButton.js